import { useEffect, useState } from 'react';
import { GoArrowLeft, GoArrowRight } from 'react-icons/go';
import ReactPaginate from 'react-paginate';

import { PropsWithClassName } from '@/types';
import { cn } from '@/utils';

type Props<T, K> = PropsWithClassName<{
  itemsPerPage?: number;
  items: Array<T | K>;
  currentContentPage: (obj: Array<T | K>) => void;
  currentNumberPage?: (page: number) => void;
  loadMore?: (pageNumber?: number) => void;
  totalItems?: number;
  marginPagesDisplayed?: number;
  breakLabel?: string | React.ReactNode;
  pageRangeDisplayed?: number;
  usePageLabelBuilder?: boolean;
}>;
export const Paginator = <T, K>({
  itemsPerPage = 10,
  items,
  currentContentPage,
  currentNumberPage,
  totalItems,
  className,
  marginPagesDisplayed = 0,
  breakLabel = '',
  pageRangeDisplayed,
  usePageLabelBuilder = false,
}: Props<T, K>) => {
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const totalPages = totalItems
      ? Math.ceil(totalItems / itemsPerPage)
      : Math.ceil(items.length / itemsPerPage);
    setPageCount(totalPages);
    const startOffset = currentPage * itemsPerPage;
    const endOffset = startOffset + itemsPerPage;
    currentContentPage(items.slice(startOffset, endOffset));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, itemsPerPage, items, totalItems]);

  const handlePageClick = async (page: { selected: number }) => {
    setCurrentPage(page.selected);
    currentNumberPage && currentNumberPage(page.selected);
  };

  return (
    <ReactPaginate
      activeClassName="active"
      breakLabel={breakLabel}
      className={cn('paginator-gdt w-full items-center ', className)}
      containerClassName="w-full"
      forcePage={currentPage}
      marginPagesDisplayed={marginPagesDisplayed}
      nextClassName="page-item"
      nextLabel={
        <div className="flex items-center">
          <span className="pr-2">Siguiente</span>
          <GoArrowRight size={15} />
        </div>
      }
      pageClassName={breakLabel !== '' ? '' : 'page-item'}
      pageCount={pageCount}
      pageLabelBuilder={
        usePageLabelBuilder
          ? (page) => (
              <span className="flex items-center gap-x-1">
                <span>{page}</span> de <span>{pageCount}</span>
              </span>
            )
          : undefined
      }
      pageRangeDisplayed={pageRangeDisplayed}
      previousLabel={
        <div className="flex items-center">
          <GoArrowLeft size={15} />
          <span className="pl-2">Anterior</span>
        </div>
      }
      onPageChange={handlePageClick}
    />
  );
};
